document.addEventListener("DOMContentLoaded", function () {
    //ipua
    var ipua = document.createElement("script");
    var head = document.querySelector("head");

    // Get environment variables using import.meta.env
    const ipuaBase = import.meta.env.VITE_IPUA;
    const cupEnv = import.meta.env.VITE_CUP_ENV;

    ipua.setAttribute("type", "module");
    ipua.setAttribute(
        "src",
        `${ipuaBase}/ipua/latest/${cupEnv}/assets/ipua-panel.js?no-cache=${Date.now()}`
    );
    ipua.async = true;
    head.appendChild(ipua);

    if (import.meta.env.VITE_ENV === "qa" || import.meta.env.VITE_ENV === "local") {
        // Add adobe analytics development link
        var adobeAnalyticsScriptDev = document.createElement("script");
        adobeAnalyticsScriptDev.setAttribute(
            "src",
            "//assets.adobedtm.com/32ec36485c31/372aeb24c16d/launch-6875737eb25e-development.min.js"
        );
        adobeAnalyticsScriptDev.async = true;
        document.head.appendChild(adobeAnalyticsScriptDev);
    } else if (import.meta.env.VITE_ENV === "prd") {
        // Add adobe analytics development link
        // eslint-disable-next-line no-redeclare
        var adobeAnalyticsScriptDev = document.createElement("script");
        adobeAnalyticsScriptDev.setAttribute(
            "src",
            "//assets.adobedtm.com/32ec36485c31/372aeb24c16d/launch-2a732ddc79bb.min.js"
        );
        adobeAnalyticsScriptDev.async = true;
        document.head.appendChild(adobeAnalyticsScriptDev);
    }
});
